import { __assign } from "tslib";
import { PricingInclude } from './Pricing';
export var UserInclude = {
    businessUnit: true,
    organization: {
        include: {
            pricing: {
                include: PricingInclude,
            },
            industry: true,
            logo: true,
        },
    },
    userFunctions: {
        where: { deleted: false },
        include: {
            businessUnits: { where: { deleted: false } },
        },
    },
    photo: true,
    role: { include: { onboardingSteps: true } },
    notificationConfigurations: {
        include: {
            notificationTemplate: true,
        },
    },
    onboardingSteps: { include: { onboardingStep: true } },
};
export var UserSelect = {
    id: true,
    username: true,
    email: true,
    firstName: true,
    lastName: true,
    jobDescription: true,
    locale: true,
    metadata: true,
    timezone: true,
    businessUnitId: true,
    organizationId: true,
    photoId: true,
    photo: true,
    roleId: true,
    blocked: true,
    confirmed: true,
    onboarding: true,
};
export var UserSelectWithRole = __assign(__assign({}, UserSelect), { role: true });
export var UserSelectShallow = {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
    metadata: true,
    confirmed: true,
    jobDescription: true,
    role: {
        select: {
            name: true,
            type: true,
        },
    },
    businessUnit: {
        select: {
            id: true,
            key: true,
            ancestorIds: true,
            title: true,
        },
    },
    organization: {
        select: {
            pricing: {
                select: {
                    name: true,
                },
            },
        },
    },
    onboardingSteps: true,
};
export var UserWithOrganization = {
    organization: true,
};
//# sourceMappingURL=User.js.map